import { memo } from 'react'
import { Stack } from '@mui/material'
import { useRecentUsers } from '$logic/room-list/room-list-search.react-hook'
import { openUserProfile } from '$logic/router'
import { RecentUserItem } from '$common/recent-user-item'

export const RecentUsers = memo(function() {
  const recentUsers = useRecentUsers()

  return (
    <Stack direction="row" sx={{ overflow: 'auto', backgroundColor: 'white' }}>
      {recentUsers.map(({ userId }) => (
        <RecentUserItem
          key={userId}
          userId={userId}
          onSelect={() => openUserProfile(userId)}
        />
      ))}
    </Stack>
  )
})
